import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserAudit } from 'src/app/core/models/userAudit';
import { environment } from 'src/environments/environment';
import { Evento } from '../../../assets/proto-ts/evento';

@Injectable({
  providedIn: 'root',
})
export class PositionsService {
  private apiServerUrl = environment.loganConfig.url;

  constructor(private http: HttpClient) {}

  public getPositionJson(
    serial: string,
    dataEpochInit: string,
    dataEpochEnd: string,
    userAudit: UserAudit
  ): Observable<[any]> {
    return this.http.post<[any]>(
      `${this.apiServerUrl}/api/telemetria/positionJson/${dataEpochInit}/${dataEpochEnd}`,
      { serial, userAudit }
    );
  }

  public getPositionJsonWithProtoEvents(
    serial: string,
    dataEpochInit: string,
    dataEpochEnd: string,
    userAudit: UserAudit
  ): Observable<[any]> {
    return this.http.post<[any]>(
      `${this.apiServerUrl}/api/telemetria/positionJson/proto/${dataEpochInit}/${dataEpochEnd}`,
      { userAudit, serial }
    );
  }

  public getLastPositionJson(
    serial: string[],
    userAudit: UserAudit
  ): Observable<Evento> {
    return this.http.post<Evento>(
      `${this.apiServerUrl}/api/telemetria/lastpositionJson`,
      { seriais: {serial}, userAudit: userAudit },
      { withCredentials: true }
    );
  }
}
